import { api } from '../api'
import { CreateChannelEventResponse, CreateChannelEventPayload } from 'models/ChannelEvent'

export const channelEventApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChannelEvent: builder.mutation<
      CreateChannelEventResponse,
      { oid: string; body: CreateChannelEventPayload }
    >({
      query: ({ oid, body }) => ({
        url: `/organizations/${oid}/channel-events`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { createChannelEvent },
  useCreateChannelEventMutation,
} = channelEventApi
